import React from "react";
import css from "./index.module.css";

export default function ButtonGroup({
  start,
  center,
  end,
  className,
  ...props
}) {
  let alignment = css.center;
  if (start) alignment = css.start;
  if (end) alignment = css.end;

  return <div className={`${css.grid} ${className} ${alignment}`} {...props} />;
}

ButtonGroup.defaultProps = {
  start: false,
  center: true,
  end: false,
  className: ""
};
